import { formatDateBR, formatTimeBR } from '../../utils/date-utils';
import type { AvailableSpot } from '../../api/available-spots';

export function formatChatPeriod(startAt: string, endAt: string): string {
  const start = formatChatInstant(startAt);
  const end = formatChatInstant(endAt);
  if (formatDateBR(startAt) === formatDateBR(endAt)) {
    return `${start.date} · ${start.time}–${end.time}`;
  }
  return `${start.date} ${start.time} → ${end.date} ${end.time}`;
}

export function formatChatSpotPlace(spot: AvailableSpot): string {
  const block = spot.blockCode
    ? `${spot.blockName} (${spot.blockCode})`
    : spot.blockName;
  const place = [spot.level, spot.location].filter(Boolean).join(' · ');
  return [block, place].filter(Boolean).join(' · ');
}

export function chatSpotKind(spot: AvailableSpot): {
  label: string;
  tone: 'own' | 'rent' | 'borrow';
} {
  if (spot.isMine) return { label: 'Sua vaga', tone: 'own' };
  const allowRent = spot.availabilityWindows.some((window) => window.allowRent);
  const allowBorrow = spot.availabilityWindows.some((window) => window.allowBorrow);
  if (allowRent && !allowBorrow) return { label: 'Aluguel', tone: 'rent' };
  if (allowBorrow && allowRent) return { label: 'Disponível', tone: 'borrow' };
  return { label: 'Empréstimo', tone: 'borrow' };
}

function formatChatInstant(iso: string): { date: string; time: string } {
  const date = formatDateBR(iso);
  const time = formatTimeBR(iso);
  const year = String(new Date().getFullYear());
  return {
    date: date.endsWith(`/${year}`) ? date.slice(0, 5) : date,
    time,
  };
}
